import { render, staticRenderFns } from "./ModalIniciarProcesso.vue?vue&type=template&id=55ed23ac&scoped=true"
import script from "./ModalIniciarProcesso.vue?vue&type=script&lang=ts"
export * from "./ModalIniciarProcesso.vue?vue&type=script&lang=ts"
import style0 from "./ModalIniciarProcesso.vue?vue&type=style&index=0&id=55ed23ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ed23ac",
  null
  
)

export default component.exports